import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { formatDateString } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";
import { useEventsTracker } from "@circle-react/hooks/analytics/useEventsTracker";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { useResumePlan } from "@circle-react/hooks/useResumePlan";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

const formatCancellationDate = (endsAt: string | null | undefined) => {
  if (!endsAt) return "";
  return formatDateString(endsAt, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const ResumeBanner = () => {
  const { currentCommunity } = usePunditUserContext();
  const { resumePlan, isLoading } = useResumePlan();
  const { trackEvent } = useEventsTracker();
  const { isCircleV4 } = useCircleV4();

  const cancellationDate = formatCancellationDate(
    currentCommunity?.subscription?.ends_at,
  );

  if (!cancellationDate) return null;

  const handleResumeClick = () => {
    trackEvent("billing_page.cancellation_banner.resume_plan.clicked", {
      current_tier: currentCommunity?.current_plan_tier,
    });
    resumePlan();
  };

  if (isCircleV4) {
    return (
      <Banner
        variant="warning"
        icon="triangle-exclamation"
        iconColor="warning"
        title={t("cancellation_banner.title", { date: cancellationDate })}
        actionProps={{
          variant: "primary",
          children: t("cancellation_banner.resume_plan"),
          onClick: handleResumeClick,
          disabled: isLoading,
        }}
      />
    );
  }

  return (
    <div>
      <div className="text-darkest flex items-center gap-2">
        <Icon aria-hidden="true" type="16-clock" size={16} />
        <Typography.BodySm weight="font-semibold" size="text-md">
          {t("cancellation_banner.title", { date: cancellationDate })}
        </Typography.BodySm>
        <Button
          className="ml-1 text-md font-semibold"
          variant="circle"
          onClick={handleResumeClick}
          disabled={isLoading}
        >
          {t("cancellation_banner.resume_plan")}
        </Button>
      </div>
    </div>
  );
};
